import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import RemoveReasonEditForm from "./Forms/RemoveReasonEditForm";
import { TitleRemoveReasonTypes } from "./Constant/Source";

const RemoveReasonEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleRemoveReasonTypes.edit} component="div">
      <RemoveReasonEditForm {...props} />
    </Edit>
  );
};

export default RemoveReasonEdit;
